
  var _styles = {
  "max-demo-title": {
    "fontSize": "0.6rem",
    "fontWeight": "bold",
    "marginTop": "0.26667rem",
    "marginRight": 0,
    "marginBottom": "0.26667rem",
    "marginLeft": 0,
    "paddingTop": "1.06667rem",
    "display": "flex",
    "flexDirection": "row"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-bold2.0', 'url("https://s0.meituan.net/bs/tempfs/file/dongxiaoxue/MTfin-bold2.0.ttf") format("truetype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/tex-external-advertising/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  